import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { TeacherProfileProjectList } from './TeacherProfileProjectList.js';
import { GiveWidgetMixin } from '../common/GiveWidgetMixin.js';
import { TabsMixin } from '../common/TabsMixin.js';
import { MobileMixin } from '../common/MobileMixin.js';
import { getPage, getIndex } from '../common/requestUtils.js';
import { Svg } from '../common/Svg.js';
import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import PureRenderMixin from '../common/external-adapters/pureRenderMixinAdapter.js';
import { Immutable } from '../../external/immutable.js';
import { createTeacherSearchAPIURL } from '../search/searchApi.js';

/* global teacherId teacherPageInfo */

export const TeacherProfileProjectsController = createReactClass({

    propTypes: {
        teacherId: PropTypes.number.isRequired,
    },

    mixins: [PureRenderMixin,
        GiveWidgetMixin,
        MobileMixin,
        TabsMixin],

    getInitialState: function () {
        const stats = teacherPageInfo.stats;
        const baseTeacherApiURL = `${baseURL}common/json-teacher.html?APIKey=${dcAPIKey}&teacher=${teacherId}`;

        const validTabs = Immutable.OrderedMap().withMutations(function (map) {
            if (stats.numActiveProjects > 0 || stats.numFundedProjects > 0) {
                map.set('PROJECTS', Immutable.Map({
                    name: 'PROJECTS',
                    count: stats.numActiveProjects > 0 ? stats.numActiveProjects : undefined,
                    label: 'Projects',
                    paramName: 'projects',
                    requestURL: baseTeacherApiURL + '&max=10&index=0',
                    indexParam: 'index',
                }));
            }
        });

        return {
            validTabs,
            url: location.href,
            loading: false,
            fundedProjectsYear: this.getFundedProjectsYearQueryParameter(),
            showMobileContent: true,
        };
    },

    componentDidMount: function () {
        this.loadProjects(location.href);
    },

    handleResponse: function (data) {
        this.setState({
            loading: false,
            data: data,
            fundedProjectsYear: this.getFundedProjectsYearQueryParameter(),
        });
    },

    /**
     * Both params have the same use, but it's designed so it can be called
     * by TabsMixin, which passes an unnecessary "tab" as the first param.
     */
    requestData: function (url, otherUrl) {
        url = otherUrl || url;
        const index = getIndex(url, 10);
        const fundedProjectsYear = this.getFundedProjectsYearQueryParameter(url);
        const apiUrl = createTeacherSearchAPIURL(teacherId, index, fundedProjectsYear);
        this.requestDataAndScroll(apiUrl);
    },

    loadProjects: function (url) {
        if (this.state.loading) {
            return;
        }

        this.setState({
            url: url,
            loading: true,
        });

        history.replaceState(null, null, url);
        this.requestData(url);
    },

    getTabName: function (url) {
        return 'PROJECTS';
    },

    getFundedProjectsYearQueryParameter: function (url) {
        const param = getURLParam(url || location.href, 'fundedProjectsYear');
        return param !== undefined ? parseInt(param, 10) : undefined;
    },

    toggleMobileContent: function () {
        this.setState((prevState) => {
            return {
                showMobileContent: !prevState.showMobileContent,
            };
        });
    },

    renderMobileContentAccordion() {
        return (
            <div className={'accordion-trigger ' + (this.state.showMobileContent ? 'active' : '')}>
                <a onClick={this.toggleMobileContent}>
                    <span className="toggle-title">
                        Projects
                        <Svg icon={ this.state.showMobileContent ? 'navigateup' : 'navigatedown'} attributes={{ role: 'presentation' }}/>
                    </span>
                </a>
            </div>
        );
    },

    renderProjectList() {
        if (this.state.loading) {
            return <LoadingEllipsis />;
        } else if (this.state.data) {
            const page = getPage(this.state.url);
            return <TeacherProfileProjectList data={this.state.data} page={page} isMobile={this.state.isMobile} showGiveWidget={this.state.showGiveWidget} fundedProjectsYear={this.state.fundedProjectsYear} onClickFundedProjectsYearFilter={this.loadProjects}/>;
        }
    },

    render: function () {
        if (this.state.isMobile) {
            return (
                <div>
                    {this.renderMobileContentAccordion()}
                    {this.state.showMobileContent && this.renderProjectList()}
                </div>
            );
        } else {
            return (
                <div>
                    {this.renderProjectList()}
                </div>
            );
        }
    },

});
